import { ContextApi } from "@pancakeswap/localization";
import { FooterLinkType } from "../../../components/Footer/types";

// footer下面展示的所有链接。关于、说明、开发者
export const footerLinks: (t: ContextApi["t"]) => FooterLinkType[] = (t) => [
  {
    label: t("About"),
    items: [
      {
        label: t("Community"),
        href: "https://t.me/BNBTigerEN",
      },
      {
        label: t("Whitepaper"),
        href: "https://www.bnbtiger.top/static/upload/file/20230203/1675386735503028.pdf",
      },
      {
        label: t("Audit"),
        href: "https://github.com/Tech-Audit/Smart-Contract-Audits/blob/main/TECHAUDIT_BNBTIGER.pdf",
      },
    ],
  }
];
// export const footerLinks: (t: ContextApi["t"]) => FooterLinkType[] = (t) => [
//   {
//     label: t("About"),
//     items: [
//       {
//         label: t("Contact"),
//         href: "https://docs.pancakeswap.finance/contact-us",
//         isHighlighted: true,
//       },
//       {
//         label: t("Brand"),
//         href: "https://docs.pancakeswap.finance/brand",
//       },
//       {
//         label: t("Blog"),
//         href: "https://blog.pancakeswap.finance/",
//       },
//       {
//         label: t("Community"),
//         href: "https://docs.pancakeswap.finance/contact-us/telegram",
//       },
//       {
//         label: t("Litepaper"),
//         href: "https://v2litepaper.pancakeswap.finance/",
//       },
//     ],
//   },
//   {
//     label: t("Help"),
//     items: [
//       {
//         label: t("Customer Support"),
//         href: "https://docs.pancakeswap.finance/contact-us/customer-support",
//       },
//       {
//         label: t("Troubleshooting"),
//         href: "https://docs.pancakeswap.finance/help/troubleshooting",
//       },
//       {
//         label: t("Guides"),
//         href: "https://docs.pancakeswap.finance/get-started",
//       },
//     ],
//   },
//   {
//     label: t("Developers"),
//     items: [
//       {
//         label: "Github",
//         href: "https://github.com/pancakeswap",
//       },
//       {
//         label: t("Documentation"),
//         href: "https://docs.pancakeswap.finance",
//       },
//       {
//         label: t("Bug Bounty"),
//         href: "https://docs.pancakeswap.finance/code/bug-bounty",
//       },
//       {
//         label: t("Audits"),
//         href: "https://docs.pancakeswap.finance/help/faq#is-pancakeswap-safe-has-pancakeswap-been-audited",
//       },
//       {
//         label: t("Careers"),
//         href: "https://docs.pancakeswap.finance/hiring/become-a-chef",
//       },
//     ],
//   },
// ];